import {ICellRenderer} from 'ag-grid-community';
import {Tooltip} from 'platform/components';

import {forwardRef} from 'react';

import {useTooltipProps} from '../../hooks/useTooltipProps';
import {ICellRendererParams} from '../../types/AgGridTypes';
import {LinkPropsGetter} from '../../types/LinkPropsGetter';
import {TooltipGetter} from '../../types/TooltipGetter';
import {getCellClassName} from '../../utils/getCellClassName';
import {getMetaTextValue} from './utils/getMetaTextValue';

interface MetaTextCellRendererProps extends ICellRendererParams {
  getTooltipProps?: TooltipGetter;
  getLinkProps?: LinkPropsGetter;
}

function MetaTextCellRendererComponent(
  props: MetaTextCellRendererProps,
  _ref: React.Ref<ICellRenderer>
) {
  const {getTooltipProps, data, node, colDef} = props;
  const className = getCellClassName(colDef);
  const cellValue = getMetaTextValue(props);

  const tooltipProps = useTooltipProps(data, node, getTooltipProps);

  return (
    <Tooltip {...tooltipProps}>
      {/* eslint-disable-next-line react/forbid-dom-props */}
      <div className={className}>{cellValue}</div>
    </Tooltip>
  );
}

export const MetaTextCellRenderer = forwardRef<ICellRenderer, MetaTextCellRendererProps>(
  MetaTextCellRendererComponent
);
